import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { cloneElement } from 'react';
import { P2 } from '@zooplus/ui-components';
import styles from './Message.module.scss.js';

const Message = ({ text, icon, size, className, color, ...props }) => {
    return (jsxs("div", { "data-zta": "messageComponent", className: classNames(styles.messageContainer, className, {
            [styles.messageIconSmall]: size === 's',
            [styles.messageIconGrey]: color === 'grey',
        }), ...props, children: [jsx("i", { className: classNames(styles.messageIconContainer), "data-zta": "messageIconContainer", children: cloneElement(icon, {
                    className: styles.messageIcon,
                }) }), jsx(P2, { className: "messageText", children: text })] }));
};

export { Message as default };
//# sourceMappingURL=Message.js.map
